"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCachedEligibilityResults = exports.isReceivableResponseTape = exports.isArtifactDependencyRecord = exports.zodTypeguardFunctionWrapper = exports.zodDateTimeWireSchema = exports.zodDateTimeSchema = exports.zodValidateOrThrow = exports.getZodValidationErrors = exports.zodTypeGuardWithErrors = exports.zodArrayTypeGuard = exports.zodTypeGuard = exports.typeguardArrayFunctionLogWrapper = exports.typeguardFunctionLogWrapper = exports.throwingTypeguardWrapper = exports.typeguardFunctionWrapper = exports.reporting = exports.railz = exports.portfolioCovenant = exports.organization = exports.materializedView = exports.loanProduct = exports.insights = exports.fundingRequest = exports.finleyAi = exports.financialCovenant = exports.financialData = exports.explo = exports.deliverables = exports.date = exports.datalake = exports.creditAgreement = exports.borrowingBase = exports.datetime = exports.assetVerification = exports.assignment = void 0;
// import * as schema from '../schema';
const DbTables_1 = require("../types/DbTables");
const Log_1 = require("../types/Log");
const Receivable_1 = require("../types/Receivable");
const typeguardUtils_1 = require("./typeguardUtils");
exports.assignment = __importStar(require("./assignment"));
exports.assetVerification = __importStar(require("./assetVerification"));
exports.datetime = __importStar(require("./datetime"));
exports.borrowingBase = __importStar(require("./borrowingBase"));
exports.creditAgreement = __importStar(require("./creditAgreement"));
exports.datalake = __importStar(require("./datalake"));
exports.date = __importStar(require("./date"));
exports.deliverables = __importStar(require("./deliverables"));
exports.explo = __importStar(require("./explo"));
exports.financialData = __importStar(require("./financialData"));
exports.financialCovenant = __importStar(require("./financialCovenant"));
exports.finleyAi = __importStar(require("./finleyAi"));
exports.fundingRequest = __importStar(require("./fundingRequest"));
exports.insights = __importStar(require("./insights"));
exports.loanProduct = __importStar(require("./loanProduct"));
exports.materializedView = __importStar(require("./materializedView"));
exports.organization = __importStar(require("./organization"));
exports.portfolioCovenant = __importStar(require("./portfolioCovenant"));
exports.railz = __importStar(require("./railz"));
exports.reporting = __importStar(require("./reporting"));
__exportStar(require("./util"), exports);
var typeguardUtils_2 = require("./typeguardUtils");
Object.defineProperty(exports, "typeguardFunctionWrapper", { enumerable: true, get: function () { return typeguardUtils_2.typeguardFunctionWrapper; } });
Object.defineProperty(exports, "throwingTypeguardWrapper", { enumerable: true, get: function () { return typeguardUtils_2.throwingTypeguardWrapper; } });
Object.defineProperty(exports, "typeguardFunctionLogWrapper", { enumerable: true, get: function () { return typeguardUtils_2.typeguardFunctionLogWrapper; } });
Object.defineProperty(exports, "typeguardArrayFunctionLogWrapper", { enumerable: true, get: function () { return typeguardUtils_2.typeguardArrayFunctionLogWrapper; } });
Object.defineProperty(exports, "zodTypeGuard", { enumerable: true, get: function () { return typeguardUtils_2.zodTypeGuard; } });
Object.defineProperty(exports, "zodArrayTypeGuard", { enumerable: true, get: function () { return typeguardUtils_2.zodArrayTypeGuard; } });
Object.defineProperty(exports, "zodTypeGuardWithErrors", { enumerable: true, get: function () { return typeguardUtils_2.zodTypeGuardWithErrors; } });
Object.defineProperty(exports, "getZodValidationErrors", { enumerable: true, get: function () { return typeguardUtils_2.getZodValidationErrors; } });
Object.defineProperty(exports, "zodValidateOrThrow", { enumerable: true, get: function () { return typeguardUtils_2.zodValidateOrThrow; } });
Object.defineProperty(exports, "zodDateTimeSchema", { enumerable: true, get: function () { return typeguardUtils_2.zodDateTimeSchema; } });
Object.defineProperty(exports, "zodDateTimeWireSchema", { enumerable: true, get: function () { return typeguardUtils_2.zodDateTimeWireSchema; } });
Object.defineProperty(exports, "zodTypeguardFunctionWrapper", { enumerable: true, get: function () { return typeguardUtils_2.zodTypeguardFunctionWrapper; } });
const isArtifactDependencyRecord = (obj) => {
    const { created_at: _unusedCreatedAt, updated_at: _unusedUpdatedAt, ...remainingObj } = obj;
    const result = (0, typeguardUtils_1.zodTypeGuard)(DbTables_1.ArtifactDependencyRecordSchema)(remainingObj);
    return result;
};
exports.isArtifactDependencyRecord = isArtifactDependencyRecord;
const isReceivableResponseTape = (obj, logOptions) => {
    const result = Receivable_1.CreditFacility.ReceivableResponseTapeSchema.safeParse(obj);
    if (!result.success && logOptions?.logger) {
        const errorMessages = result.error.issues.map((issue) => {
            const path = issue.path.join('.');
            return `${path ? `${path}: ` : ''}${issue.message}`;
        });
        const error = {
            message: `Receivable Response Tape validation failed`,
            metadata: {
                logMeta: {
                    typeguard: 'isReceivableResponseTape',
                    validationErrors: errorMessages,
                },
            },
        };
        logOptions.logger(error, logOptions.logLevel || Log_1.LogLevel.Error);
    }
    return result.success;
};
exports.isReceivableResponseTape = isReceivableResponseTape;
const isCachedEligibilityResults = (obj, logOptions) => {
    const result = Receivable_1.CreditFacility.ReceivableResponseTapePreviewEligibilityStatusesSchema.safeParse(obj);
    if (!result.success && logOptions?.logger) {
        const errorMessages = result.error.issues.map((issue) => {
            const path = issue.path.join('.');
            return `${path ? `${path}: ` : ''}${issue.message}`;
        });
        const error = {
            message: `Receivable Response Tape Eligibility Statuses validation failed`,
            metadata: {
                logMeta: {
                    typeguard: 'isCachedEligibilityResults',
                    validationErrors: errorMessages,
                },
            },
        };
        logOptions.logger(error, logOptions.logLevel || Log_1.LogLevel.Error);
    }
    return result.success;
};
exports.isCachedEligibilityResults = isCachedEligibilityResults;
//# sourceMappingURL=index.js.map